import React , { useState, useRef, useEffect } from 'react';
import app from "./app" 
import {GridWrap, ListWrap, Elements} from "./helpers" 



export const PricingPlan = function({data, device, widgetType, mode}) {
    useEffect(()=>{
        if(app.getMode(mode)){ 
         
        }  
    },[])
    //console.log(data,"data-----")
    let planList = ""; 
    let layout = data.properties.layout;   
    console.log(layout,"layout...")
    if(data.elements.plansList){
        planList = data.elements.plansList.items.map(function (v,i) {
            return  <GridWrap data={v} key={'key-' + v.gridId + i} id="plansList" mode={mode} device={device}>
            
            {
                layout === "Vertical" ? <>
                    <Elements row={v.title} id={"title"} device={device} mode={mode} classType="d-inline-block"/> 
                    <Elements row={v.price} id={"price"} device={device} mode={mode}/>
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode}/>
                    <Elements row={v.list} id={"list"} device={device} mode={mode} /> 
                    <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode} classType="w-100"/> 
                </> :  <>
                    <div className="row">
                        <div className="col-lg-8">
                            <Elements row={v.heading} id={"heading"} device={device} mode={mode}/>
                            <Elements row={v.list} id={"list"} device={device} mode={mode} /> 
                        </div>
                        <div className="col-lg-4">
                            <Elements row={v.title} id={"title"} device={device} mode={mode} classType="d-inline-block"/> 
                            <Elements row={v.price} id={"price"} device={device} mode={mode}/>
                            <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode} classType="w-100"/> 
                        </div>
                    </div>
                  
                </>
                }
            
            </GridWrap>
        })

        planList = <ListWrap data={data.elements.plansList} grid={true} mode={mode} className="align-items-stretch justify-content-center">
                {planList}
        </ListWrap>
    }

    return <div className={`container-fluid p-0 position-relative layout-${layout}`}>
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} />
                <Elements row={data.elements.summary} id={"summary"} device={device} /> 
            </div>
        </div>
        {planList}
    </div>
}